import React, {useEffect, useState} from "react";
import Article from "./article";

export default function ArticlesBox({ articles, maxHeight='auto', max=5, ...props}) {
    const [filteredArticles, setFilteredArticles] = useState([]);
    const [showAll, setShowAll] = useState(false);

    useEffect(() => {
        let a = [];
        if (max<articles?.length){
            a = articles?.length ? articles.slice(0, showAll ? 666 : max) : [];
        } else {
            a = articles?.length ? articles : [];
        }
        setFilteredArticles(a);
    }, [articles, showAll]);

    return (
        <>
            <div className="card">
                <div className="card-body">
                    <div className="row" style={{maxHeight: maxHeight, overflow: 'auto'}}>
                        {!filteredArticles?.length>0 && <div className="text-muted text-center">Zatiaľ prázdne :)</div>}
                        {filteredArticles?.length>0 &&
                            filteredArticles.map((art)=>{
                                return <div key={art.id} className="col-sm-12">
                                    <Article direction="horizontal" article={art} />
                                </div>;
                            })
                        }

                        {max<articles?.length && !showAll && <div className="text-muted text-center col-sm-12 my-2">
                            <a onClick={(event)=>{event.preventDefault(); setShowAll(true)}} href="#" className="btn btn-sm btn-soft-secondary rounded-pill">Zobraz všetky <span className="mdi mdi-chevron-down"></span></a>
                        </div>}
                        {max<articles?.length && showAll && <div className="text-muted text-center col-sm-12 my-2">
                            <a onClick={(event)=>{event.preventDefault(); setShowAll(false)}} href="#" className="btn btn-sm btn-soft-secondary rounded-pill">Schovaj všetky <span className="mdi mdi-chevron-up"></span></a>
                        </div>}
                    </div>
                </div>
            </div>
        </>
    );
}
